import { useSearchParams } from 'next/navigation'

export const useCompanyBenefitsSearchParams = () => {
  const searchParams = useSearchParams()

  const activationLinkId = searchParams?.get('activationLinkId') ?? undefined
  const blinkClientId = searchParams?.get('blinkClientId') ?? undefined
  const token = searchParams?.get('token') ?? undefined
  const email = searchParams?.get('email') ?? undefined
  const code = searchParams?.get('code') ?? undefined
  const policyCode = searchParams?.get('policyCode') ?? undefined
  const sharedCode = searchParams?.get('sharedCode') ?? undefined

  return {
    activationLinkId,
    blinkClientId,
    token,
    email,
    code,
    policyCode,
    sharedCode,
  }
}
